"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var typings_1 = require("../typings");
var event_1 = tslib_1.__importDefault(require("../utils/event"));
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var BaseTracker = /** @class */ (function (_super) {
    tslib_1.__extends(BaseTracker, _super);
    function BaseTracker() {
        var _this = _super.call(this) || this;
        _this._pluginInsMap = new Map();
        return _this;
    }
    BaseTracker.prototype.getPlugin = function (name) {
        var pluginIns = this._pluginInsMap.get(name);
        if (!pluginIns) {
            logger_1.default.log("\u63D2\u4EF6" + name + "\u6CA1\u6709\u52A0\u8F7D\u6210\u529F");
        }
        return pluginIns;
    };
    BaseTracker.prototype.setTag = function (tags) {
        this.metaData.setTags(tags);
    };
    /**
     * 老通道上报自定义指标
     * @param type 自定义指标名称
     * @param value 自定义指标数值
     * @param tags 自定义指标 tags
     */
    BaseTracker.prototype.reportPerformance = function (type, value, tags) {
        this.queue.add({
            type: type,
            value: value,
            ts: Date.now(),
            tags: tags,
        });
    };
    /**
     * 上报新通道自定义指标
     * @param type 自定义指标名称
     * @param value 自定义指标数值
     * @param tags 自定义指标 tags
     */
    BaseTracker.prototype.addCustomMetrics = function (type, value, tags) {
        this.custom_queue.add({
            type: type,
            value: value,
            ts: Date.now(),
            tags: tags,
        });
    };
    BaseTracker.prototype.addError = function (error, level) {
        if (level === void 0) { level = typings_1.LEVEL.ERROR; }
        var plugin = this.getPlugin(typings_1.PLUGIN_NAME.ERROR);
        if (plugin) {
            plugin.addError(error, level);
        }
    };
    BaseTracker.prototype.addRequest = function (req) {
        var plugin = this.getPlugin(typings_1.PLUGIN_NAME.NETWORK);
        if (plugin) {
            plugin.addRequest(req);
        }
    };
    BaseTracker.prototype.setPluginInsMap = function (name, plugin) {
        if (this._pluginInsMap.has(name)) {
            logger_1.default.warn('插件实例已经加载');
            return false;
        }
        this._pluginInsMap.set(name, plugin);
    };
    /**
     * 处理使用 loader 预加载模块  预采集道德 JS异常、mutation 信息
     */
    BaseTracker.prototype.handlePreload = function () {
        var _perf_ = window._perf_;
        if (util_1.isObject(_perf_)) {
            var JsErrorPlugin_1 = this.getPlugin(typings_1.PLUGIN_NAME.ERROR);
            var js_error_queue = _perf_.js_error_queue || [];
            var unhandle_rejection_queue = _perf_.unhandle_rejection_queue || [];
            if (JsErrorPlugin_1) {
                js_error_queue.forEach(function (args) {
                    var arr = Array.prototype.slice.call(args, 0);
                    JsErrorPlugin_1.parseOnerror.apply(JsErrorPlugin_1, arr);
                });
                unhandle_rejection_queue.forEach(function (e) {
                    JsErrorPlugin_1.parseUnhandleRejection(e);
                });
            }
            var ResPlugin_1 = this.getPlugin(typings_1.PLUGIN_NAME.RESOURCE);
            var res_error_queue = _perf_.res_error_queue || [];
            if (ResPlugin_1) {
                res_error_queue.forEach(function (err) {
                    err && ResPlugin_1.handleResourceError(err);
                });
            }
            var FspPlugin_1 = this.getPlugin(typings_1.PLUGIN_NAME.FSP);
            var mutation_queue = _perf_.mutation_queue || [];
            try {
                if (FspPlugin_1) {
                    mutation_queue.forEach(function (mutationInfo) {
                        var mutations = mutationInfo.mutations, startTime = mutationInfo.startTime;
                        FspPlugin_1.mutaCallback(mutations, startTime, false);
                    });
                }
            }
            catch (error) {
                logger_1.default.log('mutation preload handle error ', error);
            }
            // 清理loader数据
            util_1.clearLoader();
        }
    };
    return BaseTracker;
}(event_1.default));
exports.default = BaseTracker;
//# sourceMappingURL=baseTracker.js.map